<template>
  <div>
    <div class="flex justify-between">
      <h4 class="tab__content__subtitle">
        <slot name="title">{{ $lang.app.EXECUTORS }}</slot>
      </h4>
      <slot name="actions"></slot>
    </div>
    <div class="block">
      <div v-for="(executor, index) in executors" :key="index" class="resolution__user block" :title="executor.position">
        <div class="resolution__user__left">
          <div class="resolution__user__avatar">
            <img src="@/assets/v2/img/user__avatar.jpg" alt="avatar" class="resolution__user__avatar__img">
          </div>
          <div class="resolution__user__info">
            <div class="resolution__user__name">{{ executor.name }}</div>
            <div class="resolution__user__rule">
              <span v-if="executorTypesGetValueByKey('RESPONSIBLE') === executor.type">
                {{ $lang.app.RESPONSIBLE }}
              </span>
              <span v-if="executorTypesGetValueByKey('CURATOR') === executor.type">
                {{ $lang.app.CURATOR }}
              </span>
              <span v-if="executorTypesGetValueByKey('CLOSING_SIGNER') === executor.type">
                {{ $lang.app.CLOSING_SIGNER }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getValueByKey as executorTypesGetValueByKey} from "../../../../helpers/constants/executorTypes";

export default {
  props: {
    executors: Array,
    resolution: Object,
  },
  methods: {
    executorTypesGetValueByKey,
  },
}
</script>